<template>
    <div class="resultModal">
        <div class="wrapper">
            <div class="title" v-html="title"></div>
            <div class="desc" v-html="desc"></div>
            <slot name="cover"></slot>
            <a class="btn" v-html="btnLabel" @click="handleBtnClick"></a>
            <a href="javascript:;" class="close" @click="close"></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DrawResultModal',
    props: {
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        btnLabel: {
            type: String,
            default: ''
        },
        btnUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('close');
        },
        handleBtnClick() {
            if (this.btnUrl) {
                window.location.href = this.btnUrl;
            }
            this.$emit('btn-click');
            this.close();
        }
    }
};
</script>

<style lang="less" scoped>
.resultModal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    .wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding: 17px 0;
        background: url('./images/bg.png') no-repeat center;
        background-size: auto 100%;
        .title {
            position: relative;
            width: 260px;
            margin: 0 auto 10px;
            text-align: center;
            font-size: 32px;
            line-height: 32px;
            color: #fff;
            font-family: 'brSemiBold';
            &::before,
            &::after {
                position: absolute;
                top: 0;
                transform: translateY(50%);
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center;
            }
            &::before {
                width: 36px;
                height: 38px;
                background-image: url('./images/star-left.png');
                left: -20px;
            }
            &::after {
                width: 33px;
                height: 40px;
                background-image: url('./images/star-right.png');
                right: -20px;
            }
        }
        .cover {
            display: block;
            margin: 0 auto 20px;
            height: 160px;
            object-fit: contain;
        }
        .desc {
            margin-bottom: 20px;
            line-height: 1.2;
            text-align: center;
            font-size: 20px;
            color: #fff;
        }
        .btn {
            margin: 0 auto;
            display: block;
            width: 210px;
            background-color: #ff6900;
            border-radius: 25px;
            text-align: center;
            line-height: 40px;
            font-size: 18px;
            color: #fff;
            font-family: 'brSemiBold';
        }
        .close {
            position: absolute;
            display: block;
            width: 24px;
            height: 24px;
            background-image: url('./images/close.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            bottom: -56px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
